module.exports = __webpack_public_path__ + "img/3_138.4babed1d.png";